import { useRef, useEffect, useState, Suspense, lazy } from 'react';
import { Effects } from '@react-three/drei';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Canvas, useFrame, extend } from '@react-three/fiber';
import { UnrealBloomPass } from 'three-stdlib';
import gsap from 'gsap'; 
import tunnel from 'tunnel-rat'
import { Stats } from '@react-three/drei'

import Home from './pages/Home';
import Map from './pages/Map';
import About from './pages/About';
import EnergyFlow from "./pages/EnergyFlow";
import SmartPowering from "./pages/SmartPowering";
import Charge from './pages/Charge';
import Autonomy from './pages/Autonomy';
import Captation from './pages/Captation';
import VilleLaboratoire from './pages/VilleLaboratoire';
import Autoroute from './pages/Autoroute';
import RoutesCampagne from './pages/RoutesCampagne';

import Tracks from "./assets/energy/Tracks.jsx"
import NavBar from './components/Navbar';
import Fog from './components/effects/Fog';
import Camera from './components/utils/Camera';
import Loader from './components/utils/Loader.jsx';
import BaseMap from "./components/BaseMap";
import Truck from "./components/Truck";
import Cars from "./components/Car";
import Generator from './assets/energy/Generator.jsx';
import { AudioProvider } from './components/utils/AudioContext.jsx';

const html = tunnel()
extend({ UnrealBloomPass });




export default function App () {
    const [truckPos, setTruckPos] = useState(0);
   return (
      <>
        <Suspense fallback={<Loader />}>
            <BrowserRouter>
                <AudioProvider>
                    <html.Out />
                    <Canvas flat camera={{ fov: 45, near: 1, far: 1500, position: [-1200, 20, -200]}}>
                        <color args={['#fbf8f4']} attach="background" />
                        <Fog /> 
                        <Camera truckPos={truckPos}/>
                        <BaseMap scale={[1,1,1]} />
                        <Truck isMooving={true} setTruckPos={setTruckPos}/>
                        <Tracks truckPos={truckPos}/>
                        <Cars />
                        <Elec1/>
                        <html.In><About /></html.In>
                        <html.In><EnergyFlow /></html.In>
                        <html.In><SmartPowering/></html.In>
                        <html.In><Captation/></html.In>
                        <html.In><Charge/></html.In>
                        <html.In><Autonomy/></html.In>
                        <html.In><VilleLaboratoire/></html.In>
                        <html.In><Autoroute/></html.In>
                        <html.In><RoutesCampagne/></html.In>
                        <Map />
                        <Routes>
                            <Route path="/" element={<html.In><Home/></html.In>} />
                            <Route path="/about" element={<html.In><NavBar/></html.In>}/>
                            <Route path="/energyflow" element={<html.In><NavBar/></html.In>}/>
                            <Route path="/smartpowering" element={<html.In><NavBar/></html.In>}/>
                            <Route path="/captation" element={<html.In><NavBar/></html.In>}/>
                            <Route path="/charge" element={<html.In><NavBar/></html.In>}/>
                            <Route path="/autonomy" element={<html.In><NavBar/></html.In>}/>
                            <Route path="/map" element={<><html.In><NavBar/></html.In></>} />
                            <Route path="/autoroute" element={<html.In><NavBar/></html.In>}/>
                            <Route path="/villelaboratoire" element={<html.In><NavBar/></html.In>}/>
                            <Route path="/routescampagne" element={<html.In><NavBar/></html.In>}/>
                        </Routes>
                    </Canvas>
                </AudioProvider>
            </BrowserRouter>
        </Suspense>
      </>
   );
};





function Elec1() {
    const bloomPassRef = useRef(null);
    const strengthRef = useRef(0);
    const [opacity, setOpacity] = useState(0);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/energyflow' || location.pathname === '/smartpowering') {
            gsap.to({ opacity }, {
                duration: 3, 
                opacity: 1,
                onUpdate: function() {
                    setOpacity(this.targets()[0].opacity);
                }
            });
        } else {
            gsap.to({ opacity }, {
                duration: 2,
                opacity: 0,
                onUpdate: function() {
                    setOpacity(this.targets()[0].opacity);
                }
            });
        }
    }, [location]);

    useFrame(({ clock }) => {
        const elapsedTime = clock.getElapsedTime();
        const amplitude = 0.2;
        const frequency = 5; 
        const strength = amplitude * Math.sin(frequency * elapsedTime);
        strengthRef.current = strength + 0.4;
        if (bloomPassRef.current) {
            bloomPassRef.current.strength = strengthRef.current;
        }
    });

    return (
        <>
            <Generator opacity={opacity}/>
            <Effects disableGamma>
                <unrealBloomPass
                    ref={bloomPassRef}
                    threshold={1}
                    strength={strengthRef.current} 
                    radius={0.02}
                />
            </Effects>
        </>
    );
}